import React from "react";
import ReactDOM from "react-dom/client";
// Fontes do DS v3 servidas pelo próprio bundle (a CSP — font-src 'self' — barra o Google Fonts).
// Só o subset latin (cobre o português) e só os pesos usados; o navegador baixa cada arquivo
// apenas quando algum texto o usa.
import "@fontsource/libre-franklin/latin-400.css";
import "@fontsource/libre-franklin/latin-500.css";
import "@fontsource/libre-franklin/latin-600.css";
import "@fontsource/libre-franklin/latin-700.css";
import "@fontsource/lora/latin-400.css";
import "@fontsource/lora/latin-400-italic.css";
import "@fontsource/lora/latin-600.css";
import "@fontsource/lora/latin-700.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "@fontsource/ibm-plex-mono/latin-600.css";
import "@/index.css";
import App from "@/App";
import { msalInstance } from "./msalConfig";

// Inicializar MSAL antes de renderizar
msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}).catch((error) => {
  console.error("Erro ao inicializar MSAL:", error);
});
